<template>
    <div>
        <DashboardBig
                v-if="dashboardBigList != null"
                :dashboardList="dashboardBigList"
        ></DashboardBig>
        <DashboardSmall
                v-if="dashboardSmallList != null"
                :dashboardList="dashboardSmallList"
        ></DashboardSmall>
    </div>
</template>
<script>

//helper
// import Util from '@/helper/Utility.js';
import Locale from "@/helper/locale/Locale.js";
//component
import DashboardBig from './DashboardBig.vue';
import DashboardSmall from './DashboardSmall.vue';
//service
import { SubDashboardConfigBuilder } from "@/core/Campaign/config/DashboardConfigModel.js";
import BzbsDashboard from "@/core/Campaign/service/BzbsDashboard.js";

/**
 * @event onLoaded
 */
export default {
    name: "DashboardSlider",
    components: {
        DashboardBig,
        DashboardSmall,
    },
    props: {
        apiConfig: { type: String, required: true },
    },
    data: function() {
        return {
            arrDashboard: [],
            dashboardBigList: null,
            dashboardSmallList: null,
        };
    },
    created: function() {
        this.getDashboard();
    },
    methods: {
        getDashboard: function() {
            var configBuilder = new SubDashboardConfigBuilder();
            configBuilder.setLocale(Locale.getLocaleCode());

            var params = configBuilder.create().getParams();
            BzbsDashboard.apiGetSubDashboard(params, this.apiConfig).subscribe((data) => {
                // Util.log('dashboard', data);
                this.arrDashboard = data;
                this.setDashboard();

                this.$emit('onLoaded');
            }, (err) => {
                this.$emit('onLoaded');
                console.log(err);
            });
        },

        setDashboard: function () {
            let bigDashboard = this.arrDashboard.find((item) => {
                return item.size == 'big';
            });
            let smallDashboard = this.arrDashboard.find((item) => {
                return item.size == 'small';
            });

            this.dashboardBigList = bigDashboard?.subCampaignDetails;
            this.dashboardSmallList = smallDashboard?.subCampaignDetails;
        },
    },
}
</script>
<style lang="scss" scoped>
</style>
